import { render, staticRenderFns } from "./ProductsTextilesPage.vue?vue&type=template&id=49cb7826&scoped=true&"
import script from "./ProductsTextilesPage.vue?vue&type=script&lang=js&"
export * from "./ProductsTextilesPage.vue?vue&type=script&lang=js&"
import style0 from "./ProductsTextilesPage.vue?vue&type=style&index=0&id=49cb7826&prod&lang=scss&"
import style1 from "./ProductsTextilesPage.vue?vue&type=style&index=1&id=49cb7826&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb7826",
  null
  
)

export default component.exports